/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Audit_CsvInputs */

const cs_gdpr_audit_csv = /** @type {(inputs: Gdpr_Audit_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export CSV`)
};

const en_gdpr_audit_csv = /** @type {(inputs: Gdpr_Audit_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export CSV`)
};

/**
* | output |
* | --- |
* | "Export CSV" |
*
* @param {Gdpr_Audit_CsvInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_audit_csv = /** @type {((inputs?: Gdpr_Audit_CsvInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Audit_CsvInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_audit_csv(inputs)
	return cs_gdpr_audit_csv(inputs)
});